import { isNil, not } from 'ramda'

/**
 * Union type of `null` and `undefined`. Works nicely in conjunction with Ramda's isNil function.
 */
export type Nil = null | undefined

export function isString(x: unknown): x is string {
    return typeof x === 'string'
}

export function isNumber(x: unknown): x is number {
    return typeof x === 'number'
}

export function* idGenerator(prefix: string): IterableIterator<string> {
    let index = 0
    while (true) {
        yield `${prefix}-${index++}`
    }
}

export function isNotNil<T>(valueToCheck: T | Nil): valueToCheck is T {
    return not(isNil(valueToCheck))
}

// ------------------------------------------------------------------------------
//      Error formatting
// ------------------------------------------------------------------------------

/**
 * Normalizes an unknown error type to a string for error reporting.
 */
export function errorMessage(error: unknown): string {
    return error instanceof Error ? error.message : String(error)
}
